import React from "react";
// Build: only the icons named somewhere in src (see iconMap in vite.config.mjs).
import * as LucideIcons from "virtual:icon-map";
import { HelpCircle } from "lucide-react";

function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) {
  const IconComponent = LucideIcons?.[name]; // expects PascalCase, e.g. "AlertCircle"

  if (!IconComponent) {
    // fallback if the name doesn’t match any icon
    return (
      <HelpCircle
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}

export default Icon;
